<template>
  <form-group
    :name="name"
    :label="label"
    :required="required"
    :inline="inline"
    :errors="errors"
  >
    <div class="input-group">
      <ul class="icolors" v-for="option in options" :key="option">
        <li
          :name="name"
          :class="{
            [option]: option,
            active: values && values.includes(option)
          }"
          @click="selectColor(option)"
          v-tooltip="option"
        />
      </ul>
    </div>
    <slot />
  </form-group>
</template>

<script>
import FormGroup from './FormGroup';

export default {
  name: "ColorPicker",
  components: {
    FormGroup
  },
  props: ["name", "values", "label", "options", "required", "options", "errors", "inline"],
  methods: {
    selectColor(color) {
      if (this.values.indexOf(color) === -1)
        this.$emit("input", [...this.values, color]);
      else this.$emit("input", this.values.filter(v => v !== color));
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icolors li {
  cursor: pointer;
}
</style>
